import { CircleCheckBig } from "lucide-react";
import { Reveal } from "./shared";

const REASONS = [
  "Every session delivered by a doctor",
  "On-site at your office — anywhere in the UK",
  "Focused on practical skills and confidence, not certificates",
  "Real AED and manikin practice for every participant",
  "Groups capped at 12, so everyone gets proper hands-on time",
];

export const Why = () => (
  <section id="why" className="border-y border-[#E7E3D9] bg-white px-4 py-24 sm:px-6 lg:px-8" data-testid="why-section">
    <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <Reveal>
        <h2 className="font-display text-3xl font-bold tracking-tight text-[#14231B] sm:text-4xl lg:text-5xl">
          Why choose <span className="text-[#1E7B4F]">Desk to Defib</span>?
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-[#5F6E63]">
          Fewer than 1 in 10 people survive an out-of-hospital cardiac arrest in the UK. Bystander
          CPR and early defibrillation can more than double that — yet most employees have never
          touched a defibrillator. We exist to change that, one workplace at a time.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <ul className="space-y-4">
          {REASONS.map((r) => (
            <li key={r} className="flex items-start gap-3 rounded-2xl border border-[#E7E3D9] bg-[#F8F7F4] p-5">
              <CircleCheckBig className="mt-0.5 h-5 w-5 shrink-0 text-[#F97316]" />
              <span className="text-base font-medium text-[#14231B]">{r}</span>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
